import { createHighlightComponent } from 'instantsearch-ui-components';
import { createElement, Fragment } from 'react';
export var InternalHighlight = createHighlightComponent({
  createElement: createElement,
  Fragment: Fragment
});